import { Component, input } from '@angular/core';

@Component({
  selector: 'mbp-form-error',
  templateUrl: './mbp-form-error.component.html',
  styleUrl: './mbp-form-error.component.scss',
  imports: []
})
export class MbpFormErrorComponent {
  message = input<string | null | undefined>(undefined);
}
